import React from '../../../_snowpack/pkg/react.js';
import PropTypes from '../../../_snowpack/pkg/prop-types.js';
import styled from '../../../_snowpack/pkg/styled-components.js';
const StyledTableBody = styled.div.withConfig({
  displayName: "table-body__StyledTableBody",
  componentId: "sc-1y3vcyx-0"
})(["max-height:", ";background:linear-gradient(", " 30%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),", " 70%) 0 100%,radial-gradient(50% 0,farthest-side,rgba(0,0,0,0.2),rgba(0,0,0,0)),radial-gradient(50% 100%,farthest-side,rgba(0,0,0,0.2),rgba(0,0,0,0)) 0 100%;background:linear-gradient(", " 30%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),", " 70%) 0 100%,radial-gradient(farthest-side at 50% 0,rgba(0,0,0,0.2),rgba(0,0,0,0.01)),radial-gradient(farthest-side at 50% 100%,rgba(0,0,0,0.2),rgba(0,0,0,0.01)) 0 100%;background-repeat:no-repeat;background-color:", ";background-size:100% 40px,100% 40px,100% 12px,100% 12px;background-attachment:local,local,scroll,scroll;"], ({
  maxHeight
}) => maxHeight && `${maxHeight}`, props => props.backgroundColor, props => props.backgroundColor, props => props.backgroundColor, props => props.backgroundColor, props => props.backgroundColor);
export const TableBody = ({
  children,
  height,
  backgroundColor
}) => {
  return /*#__PURE__*/React.createElement(StyledTableBody, {
    backgroundColor: backgroundColor,
    maxHeight: height
  }, children);
};
TableBody.defaultProps = {
  backgroundColor: '#f3f4f6'
};
TableBody.propTypes = {
  height: PropTypes.string,
  backgroundColor: PropTypes.string
};